import { App } from './ps20apps';

export interface UploadedFile {
  fileName: string;
  uploadId: string;
  uploadedFileSize?: number;
}

export enum MeasureType {
  KEINE_MASSNAHME = 'KEINE_MASSNAHME',
  ZUSCHLAG = 'ZUSCHLAG',
  INDIVIDUELLE_VEREINBARUNG = 'INDIVIDUELLE_VEREINBARUNG',
}

export enum StStatus {
  VORSCHLAG_UNVOLLSTAENDIG = 'VORSCHLAG_UNVOLLSTAENDIG',
  VORSCHLAG_VOLLSTAENDIG = 'VORSCHLAG_VOLLSTAENDIG',
  ANTRAG_UNVOLLSTAENDIG = 'ANTRAG_UNVOLLSTAENDIG',
  ANTRAG_VOLLSTAENDIG = 'ANTRAG_VOLLSTAENDIG',
  FREIGEGEBEN_ZUM_VERSAND = 'FREIGEGEBEN_ZUM_VERSAND',
  VERSAND_OK = 'VERSAND_OK',
  VERSAND_FEHLERHAFT = 'VERSAND_FEHLERHAFT',
  VERDI_VERTRAG = 'VERDI_VERTRAG',
  WEITERGELEITET = 'WEITERGELEITET',
  ABGELEHNT = 'ABGELEHNT',
  VORSCHLAG_FREIGABEPFLICHTIG = 'VORSCHLAG_FREIGABEPFLICHTIG',
  VORSCHLAG_GENEHMIGT = 'VORSCHLAG_GENEHMIGT',
  VORSCHLAG_ABGELEHNT = 'VORSCHLAG_ABGELEHNT',
}

export interface UnderwriterMeasure {
  type: MeasureType;
  zuschlagProzent?: number;
  vereinbarungText?: string;
}

export interface UnderwriterDecision {
  appId: App;
  angebotsId: string;
  risikoAddress: string;
  produktName: string;
  grund: string;
  vertragZeichnen: boolean | null;
  massnahmen: UnderwriterMeasure[];
  dokumentation: string;
  timestamp?: string;
  isAcceptedByAgent?: boolean;
}

export interface UnderwriterDecisionWithModalData extends UnderwriterDecision {
  underwriterName: string;
  bruttopreis: number;
  contextKey: string;
}

export interface UnderwritingFragebogen {
  angebotsId: string;
  saved: boolean;
  index: number;
  files: UploadedFile[];
  comment?: string;
  uwDecision?: UnderwriterDecision;
  underwriterName: string;
  underwriterBensl: string;
  angebotStatus?: StStatus;
  beschreibung?: string;
}
